import { useTranslation } from "react-i18next";
import { SortDropdown } from "~/components/sort-dropdown.component";
import { useProductSort } from "./product-list.use-product-sort.hook";

export function SortBy() {
	const { t } = useTranslation("product");
	const { options, sort, onSortChange } = useProductSort();
	return (
		<SortDropdown
			value={sort ?? options[0].key}
			onValueChange={onSortChange}
			options={options.map(({ key }) => key)}
			getOptionLabel={(key) => t(key)}
			triggerTestId="sort-products-by-desktop"
			triggerClassName="min-w-max hidden md:block"
		/>
	);
}
